import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = BASE ? axios.create({ baseURL: `${BASE}/api`, timeout: 15000 }) : null;

export const safeGet = async (path, fallback) => {
  if (!api) return fallback;
  try {
    const res = await api.get(path);
    return res.data ?? fallback;
  } catch {
    return fallback;
  }
};
